export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14')
];

export const server_loads = [];

export const dictionary = {
		"/(main)": [8,[3]],
		"/(main)/leaderboard": [9,[3,4],[,5]],
		"/(main)/leaderboard/raid/[raid=raid]": [11,[3,4],[,5]],
		"/(main)/leaderboard/stats": [12,[3,4],[,5]],
		"/(main)/leaderboard/stats/[raid=raid]": [13,[3,4],[,5]],
		"/(main)/leaderboard/[...path]": [10,[3,4],[,5]],
		"/(main)/prototype": [~14,[3]],
		"/(development)/storm-pixi": [7,[2]],
		"/(development)/storm": [6,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.js';